import React from "react";
import "./ASLForm.css";
import uuid from "react-uuid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { red } from "@material-ui/core/colors";

class ASLForm extends React.Component {
  textareaRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      signVideo: "",
      poseVideo: "",
      glosses: [],
      learningData: [],
      poseTimings: [],
      signTimings: [],
      wordSegments: [], // New state for individual word gallery
      currentPoseGloss: "",
      currentSignGloss: "",
      listening: false,
      letterCount: 0,
    };
    this.handleRecording = this.handleRecording.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.handleTimeUpdatePose = this.handleTimeUpdatePose.bind(this);
    this.handleTimeUpdateSign = this.handleTimeUpdateSign.bind(this);
    var SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    this.recognition = new SpeechRecognition();
    this.recognition.onresult = (event) => {
      console.log("onresult");
      const transcript = event.results[0][0].transcript;
      this.setState({ value: transcript });
      console.log("transcript==" + transcript + "==");
      if (transcript !== "") {
        console.log("getvideos");
        this.getSignVideos({
          Text: transcript,
        });
      }
    };
  }

  handleTimeUpdatePose(event) {
    const currentTime = event.target.currentTime;
    const active = this.state.poseTimings.find(t => currentTime >= t.start && currentTime <= t.end);
    if (active && active.gloss !== this.state.currentPoseGloss) {
      this.setState({ currentPoseGloss: active.gloss });
    }
  }

  handleTimeUpdateSign(event) {
    const currentTime = event.target.currentTime;
    const active = this.state.signTimings.find(t => currentTime >= t.start && currentTime <= t.end);
    if (active && active.gloss !== this.state.currentSignGloss) {
      this.setState({ currentSignGloss: active.gloss });
    }
  }

  handleChange = (event) => {
    const inputValue = event.target.value;
    const count = inputValue.replace(/[^a-zA-Z]/g, "").length;
    this.setState({ value: inputValue, letterCount: count });
  };

  handleRecording(event) {
    if (this.state.listening) {
      this.recognition.stop();
      this.setState({ listening: false });
      console.log("stopListening");
      event.preventDefault();
    } else {
      console.log("handleStartListening");
      this.recognition.start();
      this.setState({ value: "", listening: true });
      event.preventDefault();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    //call the API
    //this.getSignVideos(this.state.value);
    console.log("handleSubmit");
    this.getSignVideos({
      Text: this.state.value,
    });
  }

  async uploadFile(e) {
    console.log("File upload disabled in prototype mode.");
  }

  async getSignVideos(queryStringParameters) {
    console.log(queryStringParameters);
    this.setState({signVideo:null,
      poseVideo:null })
    
    const url = "https://p6j2rk8clj.execute-api.us-east-1.amazonaws.com/Prod/";

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(queryStringParameters)
      });
      
      const data = await response.json();
      console.log(data);

      this.setState({
        signVideo: data.SignURL,
        poseVideo: data.PoseURL,
        glosses: data.Glosses || [],
        learningData: data.Learning || [],
        poseTimings: data.PoseTimings || [],
        signTimings: data.SignTimings || [],
        wordSegments: data.WordSegments || [], // Store individual word clips
        currentPoseGloss: "",
        currentSignGloss: "",
      });
    } catch (error) {
      console.log("Error calling API: ", error);
    }
  }

  render() {
    return (
      <div>
        <section className="discover-section">
          <div className="translate-view">
            <div className="box">
              <div>
                <p className="box-header">English</p>
                <div
                  style={{
                    width: "100%",
                    height: 1,
                    backgroundColor: "#D0D5DD",
                  }}
                ></div>
              </div>
              <textarea
                ref={this.textareaRef}
                value={this.state.value}
                onChange={this.handleChange}
                className="text-area"
                style={{
                  outline: 0,
                  boxSizing: "border-box",
                  padding: 10,
                  border: 0,
                }}
              />
              <div className="box-setting">
                <div>
                  <p className="letter-count">{this.state.letterCount}/500</p>
                </div>
                <div className="function-comp">
                  <div className="translate-btn">
                    <Tooltip
                      title="Translate English to ASL"
                      className="button-tooltip"
                    >
                      <IconButton onClick={this.handleSubmit}>
                        <img
                          className="translate-img"
                          src={require("../assets/sign-language-green.png")}
                          alt="Translate Button"
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div className="upload-btn">
                    <input
                      accept="audio/*"
                      id="icon-button-file"
                      type="file"
                      onChange={this.uploadFile}
                    />
                    <label htmlFor="icon-button-file">
                      <Tooltip title="Upload Audio" className="button-tooltip">
                        <IconButton
                          color="primary"
                          aria-label="upload audio"
                          component="span"
                        >
                          {/* <PhotoCamera /> */}
                          <img
                            className="upload-img"
                            src={require("../assets/upload-red.png")}
                            alt="Upload Button"
                          />
                        </IconButton>
                      </Tooltip>
                    </label>
                  </div>
                  <div className="speaker-btn">
                    <Tooltip
                      title={
                        this.state.listening ? "Stop Recording" : "Record Audio"
                      }
                      className="button-tooltip"
                    >
                      <IconButton onClick={this.handleRecording}>
                        <img
                          className="speaker-img"
                          src={
                            this.state.listening
                              ? require("../assets/stop-button.png")
                              : require("../assets/voice-blue.png")
                          }
                          alt="Speak Button"
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div className="box">
              <div>
                <p className="box-header">Avatar</p>
                <div
                  style={{
                    width: "100%",
                    height: 1,
                    backgroundColor: "#D0D5DD",
                  }}
                ></div>
              </div>
              <div className="pose-video" style={{ position: 'relative' }}>
                <video
                  key={"pose" + this.state.poseVideo}
                  autoPlay
                  playsInline
                  loop
                  muted
                  style={{ width: "100%", height: "100%" }}
                  onTimeUpdate={this.handleTimeUpdatePose}
                >
                  <source src={this.state.poseVideo} />
                </video>
                {this.state.currentPoseGloss && (
                  <div style={{
                    position: 'absolute',
                    bottom: '20px',
                    width: '100%',
                    textAlign: 'center',
                    color: '#00ff00',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px #000'
                  }}>
                    {this.state.currentPoseGloss}
                  </div>
                )}
              </div>
            </div>
            <div className="box">
              <div>
                <p className="box-header">American Sign Language</p>
                <div
                  style={{
                    width: "100%",
                    height: 1,
                    backgroundColor: "#D0D5DD",
                  }}
                ></div>
              </div>
              <div className="sign-video" style={{ position: 'relative' }}>
                <video
                  key={"sign" + this.state.signVideo}
                  autoPlay
                  playsInline
                  loop
                  muted
                  style={{ width: "100%", height: "100%" }}
                  onTimeUpdate={this.handleTimeUpdateSign}
                >
                  <source src={this.state.signVideo} />
                </video>
                {this.state.currentSignGloss && (
                  <div style={{
                    position: 'absolute',
                    bottom: '20px',
                    width: '100%',
                    textAlign: 'center',
                    color: '#ffffff',
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px #000'
                  }}>
                    {this.state.currentSignGloss}
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.state.glosses.length > 0 && (
            <div className="gloss-display" style={{ 
              textAlign: 'center', 
              margin: '20px', 
              padding: '15px', 
              backgroundColor: '#f8f9fa', 
              borderRadius: '8px',
              border: '1px solid #dee2e6'
            }}>
              <span style={{ fontWeight: 'bold', color: '#666' }}>ASL Translation: </span>
              {this.state.glosses.map((g, i) => (
                <span key={i} style={{ 
                  margin: '0 5px', 
                  padding: '5px 10px', 
                  backgroundColor: '#e9ecef', 
                  borderRadius: '4px',
                  fontWeight: 'bold',
                  color: '#2d3436'
                }}>
                  {g} {i < this.state.glosses.length - 1 ? ' → ' : ''}
                </span>
              ))}
            </div>
          )}

          {this.state.wordSegments.length > 0 && (
            <div className="sign-gallery" style={{
              margin: '20px',
              padding: '20px',
              backgroundColor: '#fff',
              borderRadius: '12px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              border: '1px solid #e0e0e0'
            }}>
              <h3 style={{ marginTop: 0, color: '#2d3436', borderBottom: '2px solid #0984e3', paddingBottom: '10px' }}>
                Sign-by-Sign Gallery
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                {this.state.wordSegments.map((segment, i) => (
                  <div key={i} style={{
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #dee2e6',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '1.2rem', color: '#2d3436' }}>
                      {segment.gloss}
                    </div>
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '0.7rem', color: '#666' }}>AVATAR</div>
                        <video autoPlay loop muted playsInline style={{ width: '100%', borderRadius: '4px', backgroundColor: '#000' }}>
                          <source src={segment.pose} />
                        </video>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '0.7rem', color: '#666' }}>HUMAN</div>
                        <video autoPlay loop muted playsInline style={{ width: '100%', borderRadius: '4px', backgroundColor: '#000' }}>
                          <source src={segment.sign} />
                        </video>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {this.state.learningData.length > 0 && (
            <div className="learning-center" style={{
              margin: '20px',
              padding: '20px',
              backgroundColor: '#fff',
              borderRadius: '12px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              border: '1px solid #e0e0e0'
            }}>
              <h3 style={{ marginTop: 0, color: '#2d3436', borderBottom: '2px solid #00b894', paddingBottom: '10px' }}>
                Learn ASL Concepts
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
                {this.state.learningData.map((item, i) => (
                  <div key={i} style={{
                    padding: '15px',
                    backgroundColor: '#f1f2f6',
                    borderRadius: '8px',
                    borderLeft: '4px solid #00b894'
                  }}>
                    <div style={{ marginBottom: '8px' }}>
                      <span style={{ fontSize: '0.8rem', color: '#636e72', textTransform: 'uppercase' }}>English:</span>
                      <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{item.english}</div>
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <span style={{ fontSize: '0.8rem', color: '#636e72', textTransform: 'uppercase' }}>ASL Gloss:</span>
                      <div style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#0984e3' }}>{item.asl}</div>
                    </div>
                    <div style={{ fontSize: '0.9rem', color: '#2d3436', fontStyle: 'italic' }}>
                      "{item.explanation}"
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>
      </div>
    );
  }
}

export default ASLForm;
